import CommonUtils from "src/utils/common"

export function mapErrorMessages(map) { // eslint-disable-line import/prefer-default-export
  const methods = {}
  Object.keys(map).forEach((key) => {
    methods[key] = function errorMessage() {
      const vuelidateObj = CommonUtils.dotPath(map[key][0], this.$v)
      const errorsDefs = map[key][1]
      const errors = []
      if (!vuelidateObj.$dirty) return errors
      Object.keys(errorsDefs).forEach((errorsDefKey) => {
        if (!vuelidateObj[errorsDefKey]) {
          errors.push(this.$t(errorsDefs[errorsDefKey]))
        }
      })
      return errors
    }
  })
  return methods
}



// WEBPACK FOOTER //
// ./src/utils/vuelidate.js